<template>
  <div>
    <div v-if="!loading">
      <div class="flex flex-wrap">
        <button
          v-for="(year, index) in availableYears"
          :key="index"
          :class="[
            'bg-white p-2 rounded font-medium mt-2 mr-2 w-fit shadow-primary',
            { 'text-content-300': selectedYear !== year },
            { 'text-primary-500': selectedYear === year },
          ]"
          @click="selectYear(year)"
        >
          {{ year }}
        </button>
      </div>

      <div class="flex flex-wrap">
        <button
          v-for="(month, index) in availableMonths"
          :key="index"
          :class="[
            'bg-white p-2 rounded font-medium mt-2 mr-2 w-fit shadow-primary',
            { 'text-content-300': selectedMonth !== month.number },
            { 'text-primary-500': selectedMonth === month.number },
          ]"
          @click="selectMonth(month)"
        >
          {{ month.label }}
        </button>
      </div>
      <div v-if="report">
        <div class="flex">
          <button
            v-for="biweeklyReport in report.reports"
            :key="biweeklyReport.id"
            :class="[
              'bg-white p-2 rounded font-medium mt-2 mr-2 w-fit shadow-primary',
              { 'text-content-300': selectedReportId !== biweeklyReport.id },
              { 'text-primary-500': selectedReportId === biweeklyReport.id },
            ]"
            @click="selectReport(biweeklyReport)"
          >
            {{ formatShortDate(biweeklyReport.start_date) }} - {{ formatShortDate(biweeklyReport.end_date) }}
          </button>
        </div>

        <div v-if="selectedReport" class="flex flex-wrap">
          <div
            v-for="franchiseReport in selectedReport.franchise_biweekly_reports"
            :key="franchiseReport.id"
            class="card mt-2 mr-2 w-fit"
          >
            <!-- <h2>{{ franchiseReport.franchise.name }}</h2> -->
            <p>
              Planes (bruto):
              <span class="font-medium">{{
                integerToCurrency(
                  franchiseReport.stripe_amount +
                    (franchiseReport.coupon_discount_amount || 0) +
                    (franchiseReport.wallet_applied_amount || 0)
                )
              }}</span>
            </p>
            <p v-if="franchiseReport.coupon_discount_amount > 0" class="text-error-500">
              Descuento primera compra:
              <span class="font-medium">
                − {{ integerToCurrency(franchiseReport.coupon_discount_amount) }}
              </span>
            </p>
            <p v-if="franchiseReport.wallet_applied_amount > 0" class="text-error-500">
              Monedero canjeado:
              <span class="font-medium">
                − {{ integerToCurrency(franchiseReport.wallet_applied_amount) }}
              </span>
            </p>
            <p>
              Planes (neto cobrado):
              <span class="font-medium">{{
                integerToCurrency(franchiseReport.stripe_amount)
              }}</span>
            </p>
            <p>
              Reembolsado (Stripe):
              <span class="font-medium">{{
                integerToCurrency(franchiseReport.stripe_refunded_amount)
              }}</span>
            </p>
            <p>
              Ventas Tarjeta/Efectivo:
              <span class="font-medium">{{
                integerToCurrency(franchiseReport.incomes_amount)
              }}</span>
            </p>
            <p>
              Comisión:
              <span class="font-medium">7.5% sobre la venta neta</span>
            </p>
            <p>
              Total a pagar:
              <span class="font-semibold text-error-500">{{
                integerToCurrency(franchiseReport.total)
              }}</span>
            </p>
            <p>
              Venta neta (cantidad a recibir):
              <span class="font-semibold text-success-500">{{
                integerToCurrency(
                  franchiseReport.stripe_amount -
                    franchiseReport.stripe_refunded_amount +
                    franchiseReport.incomes_amount
                )
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Biweekly",

  data() {
    return {
      report: null,
      loading: false,
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      selectedReportId: null,
      months: [
        { number: 1, label: "Enero" },
        { number: 2, label: "Febrero" },
        { number: 3, label: "Marzo" },
        { number: 4, label: "Abril" },
        { number: 5, label: "Mayo" },
        { number: 6, label: "Junio" },
        { number: 7, label: "Julio" },
        { number: 8, label: "Agosto" },
        { number: 9, label: "Septiembre" },
        { number: 10, label: "Octubre" },
        { number: 11, label: "Noviembre" },
        { number: 12, label: "Diciembre" },
      ],
      reportIdToRegenerate: null,
    };
  },

  computed: {
    availableYears() {
      const currentYear = new Date().getFullYear();
      const startingYear = 2020;
      const years = [];

      for (let year = startingYear; year <= currentYear; year++) {
        years.push(year);
      }

      return years;
    },

    availableMonths() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      if (this.selectedYear === currentYear) {
        return this.months.filter((month) => month.number <= currentMonth);
      }

      return this.months;
    },

    selectedReport() {
      if (!this.selectedReportId) {
        return null;
      }

      return this.report.reports.filter(
        (report) => report.id === this.selectedReportId
      )[0];
    },
  },

  created() {
    this.loadReport();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    formatShortDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr + "T00:00:00");
      return date.toLocaleDateString("es-MX", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    },

    async loadReport() {
      this.loading = true;

      try {
        this.report = await api.reports.getBiweeklyReport([
          { name: "year", value: this.selectedYear },
          {
            name: "month",
            value: this.selectedMonth,
          },
        ]);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    selectYear(year) {
      if (year === this.selectedYear) {
        return;
      }

      this.selectedYear = year;
      this.selectedMonth = null;
      this.report = null;
    },

    selectMonth(month) {
      if (this.selectedMonth === month) {
        return;
      }

      this.selectedMonth = month.number;

      this.loadReport();
    },

    selectReport(report) {
      if (this.selectedReportId) {
        if (this.selectedReportId === report.id) {
          this.selectedReportId = null;
        } else {
          this.selectedReportId = report.id;
        }
      } else {
        this.selectedReportId = report.id;
      }
    },
  },
};
</script>